import {Route, Routes} from 'react-router-dom'
import {AuthLayout} from '../modules/auth/AuthLayout'
import {Login, ForgotPassword, RecoverPassword, LoginGates} from '../khipu/features/auth/pages'

const AuthRoutes = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='logingates' element={<LoginGates />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='recover-password' element={<RecoverPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthRoutes}
